<input
  #phoneInput
  class="phone-number-input {{ interactionState$ | async }}"
  type="tel"
  [attr.id]="controlId"
  [class.error]="error"
  [maskito]="maskOptions"
  [value]="displayValue"
  [disabled]="isDisabled"
  (input)="handleInput($event)"
  (focus)="onFocus()"
  (blur)="onBlur()" />
